/**
 * @file 全局方法
 * @description app全局方法
 */
import { getCookiePara, docCookies } from './tools';

/**
 * 当前sessionStorage中即速应用appid的key
 */
const SPEED_APPID_KEY = 'jisuWebAppId';
/**
 * 获取当前sessionStorage中appid
 * @returns {string}
 */
export function setAppId(value) {
  return sessionStorage.setItem(SPEED_APPID_KEY, value);
}
/**
 * 获取当前sessionStorage中appid
 * @returns {string}
 */
export function getAppId() {
  return sessionStorage.getItem(SPEED_APPID_KEY);
}

/**
 * 获取当前appid
 * @returns {string}
 */
export function checkIfLogin() {
  let appId = getAppId();
  return docCookies.getItem(appId + '_webappLogin') == 1;
}



// WEBPACK FOOTER //
// ./src/utils/global.jsx